let config = {
  endpoint: 'https://wp.demo.ftlvn.com.vn/api',
  sizePerPage: 20,
}

export default config;